import type { CountryCode } from 'libphonenumber-js'
import { useTranslation } from 'next-i18next'

export interface PhoneCountry {
  countryCode: CountryCode
  name: string
  flag: string
  indicator: string
}

export const useSortedPhoneCountries = (): PhoneCountry[] => {
  const { t } = useTranslation('common.countries')

  const phoneCountries: PhoneCountry[] = [
    {
      countryCode: 'FR',
      name: t('france'),
      flag: '🇫🇷',
      indicator: '+33',
    },
    {
      countryCode: 'DE',
      name: t('germany'),
      flag: '🇩🇪',
      indicator: '+49',
    },
    {
      countryCode: 'IT',
      name: t('italy'),
      flag: '🇮🇹',
      indicator: '+39',
    },
    {
      countryCode: 'BE',
      name: t('belgium'),
      flag: '🇧🇪',
      indicator: '+32',
    },
    {
      countryCode: 'LU',
      name: t('luxemburg'),
      flag: '🇱🇺',
      indicator: '+352',
    },
    {
      countryCode: 'NL',
      name: t('netherlands'),
      flag: '🇳🇱',
      indicator: '+31',
    },
    {
      countryCode: 'GB',
      name: t('united_kingdom'),
      flag: '🇬🇧',
      indicator: '+44',
    },
    {
      countryCode: 'ES',
      name: t('spain'),
      flag: '🇪🇸',
      indicator: '+34',
    },
    {
      countryCode: 'AT',
      name: t('austria'),
      flag: '🇦🇹',
      indicator: '+43',
    },
    {
      countryCode: 'CH',
      name: t('switzerland'),
      flag: '🇨🇭',
      indicator: '+41',
    },
    {
      countryCode: 'MG',
      name: t('madagascar'),
      flag: '🇲🇬',
      indicator: '+261',
    },
    {
      countryCode: 'RE',
      name: t('reunion'),
      flag: '🇫🇷',
      indicator: '+262',
    },
    {
      countryCode: 'GP',
      name: t('guadeloupe'),
      flag: '🇬🇵',
      indicator: '+590',
    },
    {
      countryCode: 'GF',
      name: t('giuana'),
      flag: '🇬🇫',
      indicator: '+594',
    },
    {
      countryCode: 'MQ',
      name: t('martinique'),
      flag: '🇲🇶',
      indicator: '+596',
    },
    {
      countryCode: 'YT',
      name: t('mayotte'),
      flag: '🇾🇹',
      indicator: '+262',
    },
    {
      countryCode: 'MC',
      name: t('monaco'),
      flag: '🇲🇨',
      indicator: '+377',
    },
    {
      countryCode: 'NC',
      name: t('new_caledonia'),
      flag: '🇳🇨',
      indicator: '+687',
    },
    {
      countryCode: 'PF',
      name: t('polynesia'),
      flag: '🇵🇫',
      indicator: '+689',
    },
    {
      countryCode: 'PM',
      name: t('stpierre'),
      flag: '🇵🇲',
      indicator: '+508',
    },
    {
      countryCode: 'WF',
      name: t('wallis_and_futuna'),
      flag: '🇼🇫',
      indicator: '+681',
    },
  ]

  return phoneCountries.sort((left, right) =>
    left.name.localeCompare(right.name),
  )
}
